import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { ScrollArea } from "./ui/scroll-area";

export function SignalDetailDialog({
  signal,
  open,
  onOpenChange,
}) {
  if (!signal) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange} >
      <DialogContent className="max-w-2xl flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span>{signal.headline}</span>
            <Badge variant={signal.type === 'GROWTH' ? 'default' : 'destructive'}>
              {signal.type}
            </Badge>
          </DialogTitle>
        </DialogHeader>

        <ScrollArea className="max-h-[80vh] overflow-y-auto">
          <div className="space-y-6">
            {/* Summary */}
            <div>
              <h3 className="font-semibold mb-2">Summary</h3>
              <p className="text-muted-foreground">{signal.summary}</p>
            </div>

            {/* Business Rationale */}
            <div>
              <h3 className="font-semibold mb-2">Business Rationale</h3>
              <p className="text-muted-foreground">
                {signal.type === 'HIRING' && 'Strategic expansion to capture market share in emerging technology sector.'}
                {signal.type === 'PRICING' && 'Response to market pressure and competitive landscape changes.'}
                {signal.type === 'M&A' && 'Strategic acquisition to expand product portfolio and customer base.'}
                {/* Add more rationales based on signal type */}
              </p>
            </div>

            {/* Estimated Impact */}
            <div>
              <h3 className="font-semibold mb-2">Estimated Impact</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="p-4 bg-accent rounded-lg">
                  <p className="text-sm font-medium">Market Share</p>
                  <p className="text-2xl font-bold">+{Math.floor(Math.random() * 15)}%</p>
                </div>
                <div className="p-4 bg-accent rounded-lg">
                  <p className="text-sm font-medium">Revenue Impact</p>
                  <p className="text-2xl font-bold">${Math.floor(Math.random() * 100)}M</p>
                </div>
              </div>
            </div>

            {/* Strategic Implications */}
            <div>
              <h3 className="font-semibold mb-2">Strategic Implications</h3>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Potential market leadership in emerging technology sector</li>
                <li>Increased competitive pressure on similar companies</li>
                <li>Shift in industry talent distribution</li>
              </ul>
            </div>

            {/* Related Companies */}
            <div>
              <h3 className="font-semibold mb-2">Related Companies</h3>
              <div className="flex flex-wrap gap-2">
                {['Competitor A', 'Competitor B', 'Partner C'].map((company) => (
                  <Badge key={company} variant="outline">
                    {company}
                  </Badge>
                ))}
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-2">
              <Button variant="outline">View Similar Moves</Button>
              <Button>Track This Signal</Button>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
} 